// Module
var code = "<p>You&#39;ll know you&#39;ll have a <strong>Reduced Payment Bill</strong> if &quot;REDUCED PAYMENT BILL&quot; appears in the upper left-hand corner.</p> ";
// Exports
export default code;